import styled from 'styled-components';

import { metFontFamily } from '../../shared';

const StyledMainGrid = styled.div`
  margin-top: 84px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-family: ${metFontFamily};
  width: 90%

  justify-self: center;
`;

export { StyledMainGrid };
